var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"col":"12"}},[_c('div',[_c('TypeFactory',{staticClass:"mt-3",attrs:{"node":_vm.node,"editMode":_vm.editMode,"editIndex":0,"selectedRecord":_vm.selectedRecord,"singleEditModeid":'',"isRoot":_vm.isRoot,"createMode":false}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }